let quizOriginalTotal = 0;
let quizDiscountTotal = 0;

class QuizCard extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback() {
    this.render()
  }

  render() {
    const _this = this
    let url = this.dataset.url
    url += url.indexOf('?') > 0
      ? '&view=ajax-card'
      : '?view=ajax-card'

    fetch(url)
      .then(res => res.text())
      .then(res => {
        this.innerHTML = res
        const $price = this.querySelector('.js-quiz-price')
        quizOriginalTotal += $price.dataset.compareAtPrice
          ? parseInt($price.dataset.compareAtPrice)
          : parseInt($price.dataset.price)
        quizDiscountTotal += parseInt($price.dataset.price)

        _this.updateAddAllPrice()

        // Commenting the following line because Octane price and Product price are different.
        // Cart line item price is not same as Octane price
        // $price.innerHTML = this.dataset.price

        _this._attachEvents()
        ratingSnippet('ruk_rating_snippet', {
          store: 'wild-nutrition-ltd',
          color: '#000',
          linebreak: true,
          text: 'Reviews',
        })

        document.dispatchEvent(new CustomEvent('content:ajax-loaded', {
          detail: {
            el: _this
          }
        }))
      })
  }

  _attachEvents() {
    // this._enableQuickView()
    this._enableRemove()
  }

  _enableQuickView() {
    const _this = this
    const quickViewCta = this.querySelector('.js-quick-view')
    const modal = document.querySelector('.js-quickview-modal')
    const modalContent = modal.querySelector('.js-quickview-modal-content')

    if (!quickViewCta || !modal || !modalContent) {
      return
    }

    quickViewCta.addEventListener('click', (e) => {
      e.preventDefault()

      // TODO: Emit shopify:section:load event to reload the JS after card loading.
      // const productHandle = quickViewCta.getAttribute('data-product-handle')

      // fetch(`/products/${productHandle}?sections=product-quickview`)
      //   .then((res) => res.json())
      //   .then((data) => {
      //     modalContent.innerHTML = data['product-quickview']

      //     const quickviewSection = modalContent.querySelector(
      //       '.js-product-quickview'
      //     )

      //     if (quickviewSection) {
      //       reloadSection({
      //         id: 'product-quickview',
      //         section: quickviewSection
      //       })

      //       freeze('has-open-modal')

      //       modal.classList.add('active')
      //     }
      //   })


      // fetch(`/products/${$quickViewCta.dataset.handle}?view=quickview`)
      //   .then(res => res.text())
      //   .then(res => {
      //     const $modal = document.querySelector('.quick-view')
      //     if ($modal) {
      //       $modal.querySelector('.quick-view__content').innerHTML = res
      //       $modal.classList.add('quick-view--active')
      //       document.body.classList.add('util-SiteOverflowed')

      //       const rechargeConfig = {
      //         productId: parseInt($quickViewCta.dataset.productId),
      //         injectionParent: '.quick-view__content .js-subscription',
      //         selectors: {
      //           price: ['.quick-view__price .price'],
      //         },
      //       }

      //       // Try to initialize recharge widget until recharge asset is ready
      //       _this._tryRechargeInit(rechargeConfig)

      //       // eslint-disable-next-line no-undef
      //       ratingSnippet('ruk_rating_snippet', {
      //         store: 'wild-nutrition-ltd',
      //         color: '#000',
      //         linebreak: true,
      //         text: 'Reviews',
      //       })
      //     }

      //     document.dispatchEvent(new CustomEvent('content:ajax-loaded', {
      //       detail: {
      //         el: _this
      //       }
      //     }))
      //   })
    })
  }

  _enableRemove() {
    const $remove = this.querySelector('.js-remove')

    if (!$remove) return

    $remove.addEventListener('click', () => {
      const $price = this.querySelector('.js-quiz-price')
      quizOriginalTotal -= $price.dataset.compareAtPrice
        ? parseInt($price.dataset.compareAtPrice)
        : parseInt($price.dataset.price)
      quizDiscountTotal -= parseInt($price.dataset.price)

      this.updateAddAllPrice()
      this.remove()
    })
  }

  updateAddAllPrice() {
    document.querySelectorAll('.quiz-cta__add-all').forEach($btn => {
      $btn.innerHTML = "<span>Add all to basket</span>"
    })
  }
}
customElements.define('quiz-card', QuizCard)

function rebuildCard($card, products) {
  const $img = $card.querySelector('[data-element="oct-quiz-resultitemImg"]')
  if (!$img) return
  const $newCard = document.createElement('quiz-card')
  const url = new URL($img.href)
  const variantId = url.searchParams.get('variant')
  let matchingProduct = products.find(product => product.id == variantId)
  if (!matchingProduct) {
    matchingProduct = products.find(product => {
      if (product.variants) {
        const variantsList = product.variants.map(variant => variant.id);
        if (variantsList.indexOf(variantId) > -1) {
          return true;
        }
      } else {
        return false;
      }
    })
  }

  if (!matchingProduct) return;
  $newCard.dataset.url = $img.href
  $newCard.dataset.price = matchingProduct.price_formatted

  $card.parentElement.setAttribute('class', 'quiz-grid')
  $card.parentElement.replaceChild($newCard, $card)
}

function rebuildAddAll($addAll) {
  const $button = $addAll.querySelector('button')
  if (!$button) return

  const $newButton = document.createElement('button')
  $newButton.classList.add('o-button-secondary', 'quiz-cta__add-all')

  $newButton.addEventListener('click', e => {
    e.preventDefault()
    const items = []

    document.querySelectorAll('quiz-card').forEach($card => {
      const url = new URL($card.dataset.url)
      const variantId = url.searchParams.get('variant')
      items.push({ 'id': variantId, 'quantity': 1 })
    })

    // if (items.length > 0) {
    //   window.BAOCart.addMultipleItemsToCart({ items })
    // }
  })

  $button.parentElement.replaceChild($newButton, $button)
}

document.addEventListener('octane.quiz.completed', (e) => {
  document.querySelectorAll('[data-element="oct-quiz-resultitem"]').forEach($card => {
    rebuildCard($card, e.detail.product_blocks.flat())
  })

  const $quizBlocks = document.querySelectorAll('[data-element="oct-quiz-buyall oct-quiz-media"]')
  for (let i = 0; i < $quizBlocks.length; i++) {
    const element = $quizBlocks[i];
    rebuildAddAll(element)
  }

  document.querySelectorAll('[data-element="oct-quiz-btn oct-quiz-media"] button').forEach($btn => {
    $btn.classList.remove($btn.classList[0])
    $btn.classList.add('o-button-secondary', 'oct-quiz-button')
  })

  document.querySelectorAll('.sec-Benefits').forEach($section => {
    $section.classList.add('quiz-finished')
  })
})
